import * as z from "zod"

export const ContactAssociationModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  tags: z.string().array(),
  contact_id: z.number().int(),
})
